export default __webpack_public_path__ + "static/media/Icon_Envelope.d936ead7.svg";